// removed by extract-text-webpack-plugin
module.exports = {"blogEntryCard":"FJl53mfIWz63ETdmoh3dN","info":"_2HX6oNoUBaO7YTaJdhCNcV"};


/*****************
 ** WEBPACK FOOTER
 ** ../components/BlogEntryCard.module.scss
 ** module id = 1744
 ** module chunks = 0
 **/